// The edited canvases retain contact at this integer source offset.
export const KNIGHT_REARM_PADDING = { x: 0, y: 380 } as const
// PNG alpha>16 metadata, verified against the real source in the regression test.
// In the browser sprites.ts uses the loaded contact's metadata instead.
export const KNIGHT_REARM_CONTACT_META = {
  x0: 1, x1: 1248, y0: 1, y1: 930, cx: 624.5,
  w: 1250, h: 932, area: 345142,
} as const
export function isKnightRearmKey(key: string): boolean {
  return key === 'lanceSweep_rearm' || key === 'lanceSweep_rearmMid'
}
